import Header from './components/Header';
import Hero from './components/Hero';
import MediaSection from './components/MediaSection';
import FeaturesSection from './components/FeaturesSection';
import CommentsSection from './components/CommentsSection';
import AboutSection from './components/AboutSection';
import CardsSection from './components/CardsSection';
import IndexSection from './components/IndexSection';
import AppSection from './components/AppSection';
import CarouselSection from './components/CarouselSection';
import TopicsSection from './components/TopicsSection';
import ContactSection from './components/ContactSection';
import UpdatesSection from './components/UpdatesSection';
import FaqSection from './components/FaqSection';
import RankingSection from './components/RankingSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <MediaSection />
        <FeaturesSection />
        <CommentsSection />
        <AboutSection />
        <CardsSection />
        <IndexSection />
        <AppSection />
        <CarouselSection />
        <TopicsSection />
        <ContactSection />
        <UpdatesSection />
        <FaqSection />
        <RankingSection />
      </main>
      <Footer />
    </>
  );
}